import React, { useState, useMemo, useEffect } from 'react';
import formatMoney from 'utils/formatMoney';

const POOL = [2, 5, 10, 20, 50, 100, 200, 500];

function gerarCasas(premio) {
    if (premio > 0) {
        const outros = POOL.filter(v => v !== premio);
        const embaralhados = [...outros].sort(() => Math.random() - 0.5).slice(0, 3);
        return [premio, premio, premio, ...embaralhados].sort(() => Math.random() - 0.5);
    } else {
        return [...POOL].sort(() => Math.random() - 0.5).slice(0, 6);
    }
}

function Raspadinha({ bilhete, autoRevelar, onPagar }) {
    const [reveladas, setReveladas] = useState(autoRevelar ? [0, 1, 2, 3, 4, 5] : []);

    const casas = useMemo(() => {
        if (bilhete.grade && bilhete.grade.length === 6) return bilhete.grade;
        return gerarCasas(bilhete.premio ?? 0);
    }, [bilhete.id, bilhete.grade]);

    const todasReveladas = reveladas.length === 6;
    const premiado = bilhete.premio > 0;
    const revelarTudo = () => setReveladas([0, 1, 2, 3, 4, 5]);
    const revelarCasa = (i) =>
        setReveladas(prev => prev.includes(i) ? prev : [...prev, i]);

    return (
        <div style={{
            background: '#1a1a2e',
            borderRadius: 14,
            border: '2px solid #f6c90e',
            marginBottom: 14,
            overflow: 'hidden',
        }}>
            <div style={{
                background: 'linear-gradient(135deg, #f6c90e, #e6a800)',
                padding: '8px 14px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}>
                <div style={{ fontSize: 12, color: '#333', fontWeight: 'bold' }}>
                    Raspadinha #{bilhete.etapa ? `${bilhete.etapa}ª` : ''}
                </div>
                <div style={{ fontSize: 11, color: '#333' }}>
                    {todasReveladas
                        ? (premiado ? `🏆 ${formatMoney(bilhete.premio)}` : 'Não premiada')
                        : 'Clique para revelar'}
                </div>
            </div>

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: 6,
                padding: '10px 14px',
            }}>
                {casas.map((valor, i) => {
                    const revelada = reveladas.includes(i);
                    const ehVencedora = premiado && valor === bilhete.premio;
                    return (
                        <div
                            key={i}
                            onClick={() => revelarCasa(i)}
                            style={{
                                height: 54,
                                borderRadius: 8,
                                cursor: revelada ? 'default' : 'pointer',
                                position: 'relative',
                                overflow: 'hidden',
                                border: revelada && ehVencedora && todasReveladas
                                    ? '2px solid #f6c90e'
                                    : '2px solid #333',
                                background: revelada
                                    ? (ehVencedora && todasReveladas ? '#3d3500' : '#222')
                                    : '#2a2a3e',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <div style={{
                                position: 'absolute', inset: 0,
                                background: 'repeating-linear-gradient(45deg, #3a3a5a, #3a3a5a 4px, #2e2e4e 4px, #2e2e4e 8px)',
                                opacity: revelada ? 0 : 1,
                                transition: 'opacity 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#666',
                                fontSize: 16,
                            }}>💎</div>
                            <div style={{
                                opacity: revelada ? 1 : 0,
                                color: ehVencedora && todasReveladas ? '#f6c90e' : '#ddd',
                                fontWeight: 'bold',
                                fontSize: 14,
                            }}>{formatMoney(valor)}</div>
                        </div>
                    );
                })}
            </div>

            <div style={{ padding: '0 14px 10px', display: 'flex', gap: 6 }}>
                {!todasReveladas && (
                    <button
                        className="btn btn-sm btn-outline-warning"
                        style={{ flex: 1, fontSize: 11, color: '#f6c90e', borderColor: '#f6c90e' }}
                        onClick={revelarTudo}
                    >
                        Revelar
                    </button>
                )}
                {todasReveladas && premiado && bilhete.situacao === 'gerado' && onPagar && (
                    <button
                        className="btn btn-sm btn-warning"
                        style={{ flex: 1, fontWeight: 'bold', fontSize: 11 }}
                        onClick={() => onPagar(bilhete.id)}
                    >
                        Pagar prêmio
                    </button>
                )}
                {bilhete.situacao === 'pago' && (
                    <div style={{ flex: 1, color: '#5cb85c', fontSize: 11, textAlign: 'center', padding: '6px' }}>
                        ✓ Pago
                    </div>
                )}
            </div>
        </div>
    );
}

export default function ModalBilhete({ lote, bilhete: bilheteLegacy, onClose, onPagar, autoRevelar = false }) {
    // Compatibilidade: aceita prop antiga `bilhete` (1 raspadinha apenas)
    const dadosLote = lote ?? (bilheteLegacy ? {
        codigo: bilheteLegacy.codigo,
        modelo: bilheteLegacy.modelo,
        quantidade: 1,
        valor_total: bilheteLegacy.valor,
        bilhetes: [bilheteLegacy],
    } : null);

    if (!dadosLote) return null;

    const bilhetes = dadosLote.bilhetes ?? [];
    const totalPremio = bilhetes.reduce((acc, b) => acc + (b.premio ?? 0), 0);
    const totalPago = bilhetes.filter(b => b.situacao === 'pago').reduce((acc, b) => acc + (b.premio ?? 0), 0);
    const pendentesPremiadas = bilhetes.filter(b => b.situacao === 'gerado' && b.premio > 0).length;

    return (
        <div
            style={{
                position: 'fixed', inset: 0, zIndex: 9999,
                background: 'rgba(0,0,0,0.7)',
                display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
                overflowY: 'auto',
                padding: '20px 0',
            }}
            onClick={onClose}
        >
            <div
                onClick={e => e.stopPropagation()}
                style={{
                    background: '#1a1a2e',
                    borderRadius: 20,
                    width: 400,
                    overflow: 'hidden',
                    boxShadow: '0 12px 48px rgba(0,0,0,0.5)',
                    fontFamily: 'sans-serif',
                    border: '2px solid #f6c90e',
                }}
            >
                {/* Cabeçalho do cupom */}
                <div style={{
                    background: 'linear-gradient(135deg, #f6c90e, #e6a800)',
                    padding: '14px 20px',
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontWeight: 'bold', fontSize: 18, color: '#333' }}>
                            🎟️ CUPOM RASPADINHA
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: 11, color: '#555' }}>Valor Total</div>
                            <div style={{ fontWeight: 'bold', color: '#333' }}>
                                {formatMoney(dadosLote.valor_total ?? 0)}
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: 8, fontSize: 13, color: '#222' }}>
                        Código: <strong style={{ letterSpacing: 2 }}>{dadosLote.codigo}</strong>
                    </div>
                    <div style={{ fontSize: 11, color: '#555' }}>
                        {dadosLote.modelo?.nome ?? ''} · {bilhetes.length} raspadinha{bilhetes.length > 1 ? 's' : ''}
                        {totalPremio > 0 && (
                            <> · Prêmios: <strong style={{ color: '#222' }}>{formatMoney(totalPremio)}</strong></>
                        )}
                    </div>
                </div>

                {/* Resumo */}
                {bilhetes.length > 1 && (
                    <div style={{
                        padding: '8px 20px',
                        background: '#22223a',
                        color: '#ddd',
                        fontSize: 11,
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}>
                        <span>Vencedoras: {bilhetes.filter(b => b.premio > 0).length}</span>
                        <span>Pendentes: {pendentesPremiadas}</span>
                        <span>Pagas: {formatMoney(totalPago)}</span>
                    </div>
                )}

                {/* Lista de raspadinhas */}
                <div style={{ padding: '14px 20px', maxHeight: '60vh', overflowY: 'auto' }}>
                    {bilhetes.map(b => (
                        <Raspadinha
                            key={b.id ?? b.codigo}
                            bilhete={b}
                            autoRevelar={autoRevelar}
                            onPagar={onPagar}
                        />
                    ))}
                </div>

                <div style={{ padding: '0 20px 20px' }}>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        style={{ width: '100%' }}
                        onClick={onClose}
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
}
